module.exports = __webpack_public_path__ + "img/Group 680.352c118b.png";